import {actionNameGenerator} from "../../../../utils/commonUtil"
const domainPrefix = "hiw";
const hiwcActionNameGenerator = actionNameGenerator(domainPrefix);
export const fetchHowItWorksType = hiwcActionNameGenerator("fetchHowItWorks")
export const fetchHowItWorksDataSuccessType = hiwcActionNameGenerator("fetchHowItWorksDataSuccess")
export const howItWorksDataFailedType = hiwcActionNameGenerator("howItWorksDataFailed")

